import React from 'react';
import logoImage from '../../assets/logo.svg';

function Logo() {
  return <img src={logoImage} alt="site-logo" width={200} />;
}

export default Logo;
